import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    perfilIcon: {
        height: 100,
        width: 100,
        fill: theme.palette.primary.main
    },
}));